import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/github-mark.png'
import _imports_1 from '@/assets/telegram-logo.png'


const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_b_button, {
        onClick: _ctx.openGitHub,
        variant: "link",
        class: "social-button"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "GitHub"
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_b_button, {
        onClick: _ctx.openTelegram,
        variant: "link",
        class: "social-button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "Telegram"
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createTextVNode(" Version: " + _toDisplayString(_ctx.appVersion), 1)
  ]))
}